(function() {
  if (window.__cartSideDrawerUpsellBound) 
    return







  window.__cartSideDrawerUpsellBound = true

  const root = (window.Shopify && window.Shopify.routes)
    ? window.Shopify.routes.root
    : '/'
  const drawer = document.querySelector('.cart-side-drawer')
  if (! drawer) 
    return







  let inFlight = false

  function refreshCart(productData, btn) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: productData,
        addToCartBtn: btn
      }
    }))
  }

// Subscription selector: change selling plan on a cart line via /cart/change.js
  drawer.addEventListener('change', async function(e) {
    const sel = e.target.closest('[data-cart-selling-plan]')
    if (! sel) 
      return



    const lineKey = sel.dataset.lineKey
    if (! lineKey) 
      return



    const previousValue = sel.dataset.previousValue || ''
    sel.disabled = true

    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(
          {
            id: lineKey,
            selling_plan: sel.value || ''
          }
        )
      })
      if (! res.ok) 
        throw new Error('cart/change failed: ' + res.status)

      sel.dataset.previousValue = sel.value
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {}}))
    } catch (err) {
      console.error('[cart subscription]', err)
      sel.value = previousValue
    } finally {
      sel.disabled = false
    }
  })

  drawer.addEventListener('change', async function(e) {
    const cb = e.target
    if (! cb || ! cb.classList || ! cb.classList.contains('cart__item-upsell-checkbox')) 
      return







    if (inFlight) {
      cb.checked = ! cb.checked
      return
    }

    const variantId = cb.dataset.upsellVariantId
    if (! variantId) 
      return







    const promo = cb.dataset.upsellPromo || ''
    const parentProductId = cb.dataset.parentProductId || ''
    const item = cb.closest('.cart__item-upsell-item')
    const wasChecked = cb.checked

    inFlight = true
    cb.disabled = true
    if (item) 
      item.classList.toggle('is-checked', wasChecked)







    try {
      if (wasChecked) {

// Add upsell to cart. _upsell property marks the line item so cart-item.liquid
// hides it from the visible list (but it still counts toward the cart total).
        const addRes = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(
            {
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  properties: {
                    _upsell: 'true',
                    _parent: parentProductId
                  }
                }
              ]
            }
          )
        })
        if (! addRes.ok) 
          throw new Error('cart/add failed: ' + addRes.status)







        const productData = await addRes.json()

        if (promo) {
          try {
            await fetch(root + 'discount/' + encodeURIComponent(promo), {
              method: 'GET',
              credentials: 'same-origin'
            })
          } catch (err) {
            console.error('[cart upsell] failed to apply discount', promo, err)
          }
        }

        refreshCart(productData, cb)
      } else {
        const lineKey = cb.dataset.upsellLineKey
        if (! lineKey) {
          console.warn('[cart upsell] no line key on uncheck — nothing to remove')
          return
        }
        const changeRes = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(
            {id: lineKey, quantity: 0}
          )
        })
        if (! changeRes.ok) 
          throw new Error('cart/change failed: ' + changeRes.status)







        refreshCart(null, cb)
      }
    } catch (err) {
      console.error('[cart upsell]', err)
      cb.checked = ! wasChecked
      if (item) 
        item.classList.toggle('is-checked', cb.checked)







    } finally {
      cb.disabled = false
      inFlight = false
    }
  })

// ===== Orphan-upsell sweep =====
// Upsell line items carry `_upsell: 'true'` and are rendered invisibly
// inside their parent's `.cart__item-upsell` list (see cart-item.liquid).
// When the parent line is removed, those children stay in the cart but
// have no UI surface — silently inflating the total. After every cart
// re-render we ask /cart.js for the truth, drop the upsell lines whose
// parent product is no longer present, and let the cart re-render.
  let sweepInFlight = false
  let sweepQueued = false
  let sweepTimer = null

  async function sweepOrphanUpsells() {
    if (sweepInFlight) {
      sweepQueued = true
      return
    }
    sweepInFlight = true
    try {
      const res = await fetch(root + 'cart.js', {credentials: 'same-origin'})
      if (! res.ok) 
        return



      const cart = await res.json()

      const knownProductIds = new Set()
      const liveParentIds = new Set()
      drawer.querySelectorAll('.cart__item[data-upsell-product-ids]').forEach(function(el) {
        (el.dataset.upsellProductIds || '').split(',').forEach(function(id) {
          const trimmed = id.trim()
          if (trimmed)
            knownProductIds.add(trimmed)

        })
      })
      drawer.querySelectorAll('.cart__item[data-parent-product-id]').forEach(function(el) {
        const pid = (el.dataset.parentProductId || '').trim()
        if (pid)
          liveParentIds.add(pid)
      })

      const updates = {}
      let removed = 0
      cart.items.forEach(function(it) {
        if (! it.properties || it.properties._upsell !== 'true')
          return
        const parent = it.properties._parent
        if (parent) {
// New flow: child is tagged with its parent's product_id.
// Orphan = that parent line is no longer in the cart.
          if (! liveParentIds.has(String(parent))) {
            updates[it.key] = 0
            removed++
          }
        } else {
// Legacy untagged line: fall back to "any parent that promo-sets this product".
          if (! knownProductIds.has(String(it.product_id))) {
            updates[it.key] = 0
            removed++
          }
        }
      })

      if (! removed) 
        return



      const upd = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({updates})
      })
      if (! upd.ok) 
        throw new Error('cart/update failed: ' + upd.status)



      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {}}))
    } catch (err) {
      console.error('[cart upsell sweep]', err)
    } finally {
      sweepInFlight = false
      if (sweepQueued) {
        sweepQueued = false
        setTimeout(sweepOrphanUpsells, 0)
      }
    }
  }

  function scheduleSweep() {
    clearTimeout(sweepTimer)
    sweepTimer = setTimeout(sweepOrphanUpsells, 120)
  }

// Re-run after the cart drawer re-renders its line items.
  const productsHolder = drawer.querySelector('[data-products]')
  if (productsHolder) {
    const mo = new MutationObserver(scheduleSweep)
    mo.observe(productsHolder, {childList: true})
  }

  document.addEventListener('ajaxProduct:added', scheduleSweep)

// Catch orphans that were already in the cart on page load.
  scheduleSweep()

// ===== Upsell-info modal =====
// Lazy: nothing loads until the user clicks an [data-upsell-info-btn].
// Each upsell row carries a <template data-upsell-info-tpl="<product_id>">
// with the slider HTML + title/description/url. Images inside <template>
// are NOT fetched by the browser; they only start loading once the
// template content is cloned into the live DOM (i.e. when the modal opens).
  let upsellModalEl = null
  let upsellSplide = null
  let upsellOnEscape = null
  let upsellOnBackdrop = null

  function getUpsellModal() {
    if (upsellModalEl)
      return upsellModalEl
    const m = document.querySelector('[data-cart-upsell-modal]')
    if (! m)
      return null
    if (m.parentNode !== document.body)
      document.body.appendChild(m)
    upsellModalEl = m
    return m
  }

  function openUpsellModal(btn) {
    const m = getUpsellModal()
    if (! m)
      return

    const productId = btn.getAttribute('data-upsell-info-btn')
    const tpl = productId
      ? drawer.querySelector('template[data-upsell-info-tpl="' + productId + '"]')
      : null

    m.querySelectorAll('[data-cart-upsell-modal-title]').forEach(function (el) {
      el.textContent = ''
      el.style.display = 'none'
    })
    const descEl = m.querySelector('[data-cart-upsell-modal-desc]')
    if (descEl) {
      descEl.textContent = ''
      descEl.style.display = 'none'
    }
    const moreEl = m.querySelector('[data-cart-upsell-modal-more]')
    if (moreEl)
      moreEl.setAttribute('href', '#')
    const mediaSlot = m.querySelector('[data-cart-upsell-modal-media]')
    if (mediaSlot)
      mediaSlot.innerHTML = ''

    if (tpl) {
      const fragment = tpl.content.cloneNode(true)
      const titleNode = fragment.querySelector('[data-upsell-tpl-title]')
      const urlNode = fragment.querySelector('[data-upsell-tpl-url]')
      const descNode = fragment.querySelector('[data-upsell-tpl-desc]')
      const sliderNode = fragment.querySelector('[data-upsell-tpl-splide]')

      const title = titleNode ? titleNode.textContent.trim() : ''
      const url = urlNode ? urlNode.textContent.trim() : '#'
      const desc = descNode ? descNode.textContent.trim() : ''

      m.querySelectorAll('[data-cart-upsell-modal-title]').forEach(function (el) {
        if (title) {
          el.textContent = title
          el.style.display = ''
        } else {
          el.textContent = ''
          el.style.display = 'none'
        }
      })
      if (descEl) {
        if (desc) {
          descEl.textContent = desc
          descEl.style.display = ''
        } else {
          descEl.textContent = ''
          descEl.style.display = 'none'
        }
      }
      if (moreEl)
        moreEl.setAttribute('href', url)

      if (mediaSlot && sliderNode) {
        mediaSlot.appendChild(sliderNode)

        if (typeof Splide !== 'undefined') {
          const sliderEl = mediaSlot.querySelector('.splide')
          if (sliderEl) {
            const isMulti = sliderEl.querySelectorAll('.splide__slide').length > 1
            try {
              upsellSplide = new Splide(sliderEl, {
                type: isMulti ? 'loop' : 'slide',
                perPage: 1,
                arrows: isMulti,
                pagination: isMulti,
                drag: isMulti
              })
              upsellSplide.mount()
            } catch (err) {
              upsellSplide = null
            }
          }
        }
      }
    }

    m.removeAttribute('hidden')
// force reflow so the transition runs
    m.offsetHeight
    m.classList.add('is-open')

// The modal lives on <body>, outside `.cart-side-drawer__panel`. Without
// this, the side drawer's own click-outside / Esc handlers (cart-drawer.js)
// would close the drawer underneath as soon as the modal is interacted with.
    upsellOnBackdrop = function (e) {
      e.stopPropagation()
      if (e.target.closest('[data-cart-upsell-modal-close]'))
        closeUpsellModal()
    }
    m.addEventListener('click', upsellOnBackdrop)

    upsellOnEscape = function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27)
        return
      if (m.classList.contains('is-open')) {
        e.stopImmediatePropagation()
        closeUpsellModal()
      }
    }
    window.addEventListener('keyup', upsellOnEscape, true)
  }

  function closeUpsellModal() {
    const m = upsellModalEl
    if (! m)
      return
    m.classList.remove('is-open')

    if (upsellSplide) {
      try { upsellSplide.destroy(true) } catch (e) {}
      upsellSplide = null
    }
    const mediaSlot = m.querySelector('[data-cart-upsell-modal-media]')
    if (mediaSlot)
      mediaSlot.innerHTML = ''

    if (upsellOnBackdrop) {
      m.removeEventListener('click', upsellOnBackdrop)
      upsellOnBackdrop = null
    }
    if (upsellOnEscape) {
      window.removeEventListener('keyup', upsellOnEscape, true)
      upsellOnEscape = null
    }

    window.setTimeout(function () {
      if (! m.classList.contains('is-open'))
        m.setAttribute('hidden', '')
    }, 280)
  }

  drawer.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-upsell-info-btn]')
    if (! btn)
      return
    e.preventDefault()
    openUpsellModal(btn)
  })
})()
